const prefix = 'policy-details';

const SET_BASIC_INFO = `${prefix}/SET_BASIC_INFO`;

const SET_USERS = `${prefix}/SET_USERS`;

const SET_GROUPS = `${prefix}/SET_GROUPS`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_BASIC_INFO, SET_USERS, SET_GROUPS, RESET, SET_LOADING };
